import { colors } from "@/config/theme";
import {
  isManualValveReport,
  isSafetyValveReport,
  ManualValveReport,
  SafetyValveReport,
} from "@/reports/types/SafetyValveReport";
import { StyleSheet, Text, View } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 12,
    paddingTop: 4,
  },
  footerText: {
    fontSize: 8,
    color: colors.gray[800],
  },
});

type PageFooterProps = {
  data: SafetyValveReport | ManualValveReport;
};

const PageFooter = ({ data }: PageFooterProps) => {
  let name = "";

  if (isSafetyValveReport(data)) {
    name = `${data.vCustomer ?? ""}_${data.vPSVNumber ?? ""}`;
  } else if (isManualValveReport(data)) {
    name = `${data.vCustomer ?? ""}_${data.vVVNumber ?? ""}_${
      data.vValveSize ?? ""
    }_${data.vPressure ?? ""}_${data.vBody ?? ""}_${data.vType ?? ""}`;
  }

  return (
    <View style={styles.footer} fixed>
      <Text style={styles.footerText}>{`${name} | VanValve`}</Text>
      <Text
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
        style={styles.footerText}
      />
    </View>
  );
};

export default PageFooter;
